import { render, staticRenderFns } from "./PrivacyCenter.vue?vue&type=template&id=25f231e4&scoped=true"
import script from "./PrivacyCenter.vue?vue&type=script&lang=js"
export * from "./PrivacyCenter.vue?vue&type=script&lang=js"
import style0 from "./PrivacyCenter.vue?vue&type=style&index=0&id=25f231e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f231e4",
  null
  
)

export default component.exports